import React from "react";
import { Link } from "react-router-dom";
import { urlForImage } from "../utils/sanityClient";

const BlogPostCard = ({ post }) => (
  <Link
    to={`/blog/${post.slug?.current}`}
    className="group flex flex-col h-full no-underline text-[#1A1A1A] rounded-xl bg-white overflow-hidden shadow-[rgba(0,0,0,0.25)_0px_6px_18px_0px] transition-shadow duration-300 hover:shadow-[rgba(0,0,0,0.35)_0px_8px_22px_0px]"
  >
    {post.mainImage && (
      <div className="overflow-hidden">
        <img
          src={urlForImage(post.mainImage).width(600).height(338).fit("crop").url()}
          alt={post.title}
          className="w-full aspect-[16/9] object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>
    )}

    <div className="p-5 flex flex-col flex-1">
      <p className="text-[11px] font-semibold text-brand-orange uppercase tracking-wide mb-1.5">
        {post.authorName || "LasGidi Restaurant"}
        {post.publishedAt &&
          ` · ${new Date(post.publishedAt).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })}`}
      </p>

      <h2 className="font-prata font-bold text-base leading-snug mb-1.5 group-hover:text-brand-orange transition-colors">
        {post.title}
      </h2>

      {post.excerpt && (
        <p className="text-[14px] text-black/60 leading-relaxed line-clamp-2 mb-3">
          {post.excerpt}
        </p>
      )}

      <span className="mt-auto text-xs font-semibold text-brand-orange group-hover:underline">
        Read More &rarr;
      </span>
    </div>
  </Link>
);

export default BlogPostCard;
